'use client';

import dynamic from 'next/dynamic';
import { AppNextLink } from '@/features/app-next-link';
import { useCartReturnUrl } from '@/app/(order)/cart/_utils/use-cart-return-url';
import { OrderPagesURL } from '@/app/(order)/types';
import CartCounterButton from '@/app/(pdp)/_components/buttons/add-to-cart-button/cart-counter-button';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import Logo from './logo';
import UserProfile from './user-profile';
import MenuButton from './mobile-menu/menu-button';
import MobileSearch from './mobile-menu/mobile-search';
import { SearchBox } from '../search';
const MobileMenu = dynamic(() => import('./mobile-menu/mobile-menu'), {
  ssr: PUBLIC_IS_BOT
});
function MainBar() {
  const {
    setCartBackReturnUrl
  } = useCartReturnUrl();
  return <div className='layout-container relative z-10 flex items-center justify-between bg-white lg:h-[90px]' data-sentry-component="MainBar" data-sentry-source-file="main-bar.tsx">
            <div className='flex items-center gap-2 lg:gap-4'>
                <MenuButton data-sentry-element="MenuButton" data-sentry-source-file="main-bar.tsx" />
                <Logo data-sentry-element="Logo" data-sentry-source-file="main-bar.tsx" />
                <SearchBox mode='desktop' data-sentry-element="SearchBox" data-sentry-source-file="main-bar.tsx" />
            </div>

            <div className='flex items-center gap-2 md:gap-3 lg:justify-end lg:gap-5'>
                <MobileSearch data-sentry-element="MobileSearch" data-sentry-source-file="main-bar.tsx" />

                <UserProfile data-sentry-element="UserProfile" data-sentry-source-file="main-bar.tsx" />

                <AppNextLink href={OrderPagesURL.CART} prefetch={false} aria-label='Cart' onClick={setCartBackReturnUrl} className='flex items-center' data-sentry-element="AppNextLink" data-sentry-source-file="main-bar.tsx">
                    <CartCounterButton data-sentry-element="CartCounterButton" data-sentry-source-file="main-bar.tsx" />
                </AppNextLink>
            </div>

            <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="main-bar.tsx" />
        </div>;
}
export default MainBar;